__turbopack_context__.v({
  "className": "geist_mono_fcacc767-module__KVUOXa__className",
});
